import { Card, CardContent } from "ui/components/card";

import Icon from "components/icon";
import classNames from "classnames";

export function JobTypeDisplayCard({ label, icon, isSelected, onClick, id }) {

  return (
    <Card
      className={classNames("max-w-lg mx-auto shadow-none w-full", {
        "bg-muted": isSelected,
      })}
      onClick={onClick}
    >
      <CardContent className=" flex items-center gap-3">
        <Icon icon={icon} className="w-4 h-4 text-foreground shrink-0" />

        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-card-foreground">
              {label}
            </span>
            {/* <span className="text-sm text-muted-foreground">2,4mb</span> */}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
